import React from "./1.png"
import Html from "./6.png"
import Css from "./5.png"
import Javascript from "./2.png"
import Figma from "./4.png"
import Github from "./3.png"

const TOOLS = [React, Html, Css, Javascript, Figma, Github]

export default TOOLS
